import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { addMessage, clearMessageState } from "../../redux/Slices/MessageSlice";
import { toast } from "react-toastify";
import { validateFieldLanguage } from "../../Utils/languageValidation";

const AddMessage = ({ onSuccess }) => {
  const { i18n } = useTranslation("global");
  const dispatch = useDispatch();

  const { addLoading, addError, addSuccessMessage } = useSelector((state) => state.messages);

  const [formData, setFormData] = useState({
    content_ar: "",
    content_en: "",
    type: "guest",
  });

  useEffect(() => {
    dispatch(clearMessageState());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // BUG-12 fix: التحقق من الحقول المطلوبة ولغة المحتوى قبل الإرسال
    if (!formData.content_ar.trim() || !formData.content_en.trim()) {
      toast.error("يرجى إدخال محتوى الرسالة باللغتين العربية والإنجليزية");
      return;
    }
    if (!formData.type) {
      toast.error("يرجى اختيار نوع الرسالة");
      return;
    }
    const arError = validateFieldLanguage(formData.content_ar, "ar");
    if (arError) return toast.error(arError);
    const enError = validateFieldLanguage(formData.content_en, "en");
    if (enError) return toast.error(enError);

    dispatch(addMessage(formData));
  };

  useEffect(() => {
    if (addSuccessMessage) {
      toast.success(addSuccessMessage);
      setFormData({ content_ar: "", content_en: "", type: "guest" });
      if (onSuccess) onSuccess();
    }
    if (addError) {
      toast.error(addError);
    }
  }, [addSuccessMessage, addError, onSuccess]);


  const inputStyle = {
    width: "100%",
    padding: "10px 14px",
    borderRadius: 9,
    border: "1.5px solid #e2e8f0",
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    background: "#fff",
    transition: "border-color 0.2s, box-shadow 0.2s"
  };

  const labelStyle = {
    fontSize: 12,
    fontWeight: 700,
    color: "#64748b",
    display: "block",
    marginBottom: 6,
    textAlign: i18n.language === 'ar' ? 'right' : 'left'
  };

  const focusHandler = (e) => {
    e.target.style.borderColor = "var(--main-color)";
    e.target.style.boxShadow = "0 0 0 3px rgba(228, 109, 23, 0.1)";
  };

  const blurHandler = (e) => {
    e.target.style.borderColor = "#e2e8f0";
    e.target.style.boxShadow = "none";
  };

  return (
    <form onSubmit={handleSubmit} style={{ direction: i18n.language === 'ar' ? 'rtl' : 'ltr' }}>
      <style>{`
        .msg-custom-select {
          width: 100% !important;
          padding: 10px 14px !important;
          padding-left: 40px !important;
          border-radius: 9px !important;
          border: 1.5px solid #e2e8f0 !important;
          font-size: 14px !important;
          outline: none !important;
          box-sizing: border-box !important;
          background-color: #fff !important;
          appearance: none !important;
          -webkit-appearance: none !important;
          -moz-appearance: none !important;
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'></polyline></svg>") !important;
          background-repeat: no-repeat !important;
          background-position: left 14px center !important;
          background-size: 16px !important;
          cursor: pointer !important;
          transition: border-color 0.2s, box-shadow 0.2s !important;
        }
        .msg-custom-select:focus {
          border-color: var(--main-color) !important;
          box-shadow: 0 0 0 3px rgba(228, 109, 23, 0.1) !important;
        }
      `}</style>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
        <div>
          <label style={labelStyle}>المحتوى (العربية) *</label>
          <textarea
            name="content_ar"
            value={formData.content_ar}
            onChange={handleChange}
            required
            rows="3"
            placeholder="أدخل المحتوى باللغة العربية..."
            style={{ ...inputStyle, resize: "vertical" }}
            onFocus={focusHandler}
            onBlur={blurHandler}
          />
        </div>

        <div>
          <label style={labelStyle}>المحتوى (الإنجليزية) *</label>
          <textarea
            name="content_en"
            value={formData.content_en}
            onChange={handleChange}
            required
            rows="3"
            placeholder="أدخل المحتوى باللغة الإنجليزية..."
            style={{ ...inputStyle, resize: "vertical" }}
            onFocus={focusHandler}
            onBlur={blurHandler}
            dir="ltr"
          />
        </div>
      </div>

      <div style={{ marginBottom: 20 }}>
        <label style={labelStyle}>النوع *</label>
        <select
          className="msg-custom-select"
          name="type"
          value={formData.type}
          onChange={handleChange}
          required
        >
          <option value="guest">👤 زائر</option>
          <option value="first_login">🎉 أول دخول</option>
          <option value="repeat_login">🔄 دخول متكرر</option>
          <option value="inactive">😴 غير نشط</option>
          {/* BUG-11 fix: إضافة الأنواع الناقصة */}
          <option value="weekly_active">📅 نشط أسبوعياً</option>
        </select>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <button
          type="submit"
          disabled={addLoading}
          style={{
            padding: "10px 28px",
            borderRadius: 10,
            border: "none",
            background: addLoading ? "#c7d2fe" : "linear-gradient(135deg,var(--main-color),var(--main-light))",
            color: "#fff",
            fontWeight: 700,
            cursor: addLoading ? "not-allowed" : "pointer",
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontSize: 14
          }}
        >
          {addLoading ? (
            <>
              <span className="spinner-border spinner-border-sm" />
              جاري الإضافة...
            </>
          ) : (
            <>إضافة الرسالة</>
          )}
        </button>
      </div>
    </form>
  );
};

export default AddMessage;